import { Reveal } from "@/components/Kinetic";
import { TIKTOK_LINKS, TikTokIcon, scrollToId } from "@/components/Shared";
import SizeGuide from "@/components/SizeGuide";

export default function Footer() {
  return (
    <footer id="footer" className="border-t border-white/10 px-5 sm:px-10 pt-24 pb-10 overflow-hidden">
      <Reveal>
        <p className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-10">Follow the Drop</p>
      </Reveal>

      <div className="flex flex-col lg:flex-row justify-between gap-12 mb-24">
        <div className="flex flex-col gap-4">
          {TIKTOK_LINKS.map((t) => (
            <a
              key={t.handle}
              data-testid={`footer-tiktok-${t.handle.replace("@", "")}`}
              href={t.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-4 text-2xl sm:text-4xl font-display font-medium tracking-tight transition-colors duration-300"
            >
              <span className="w-11 h-11 rounded-full border border-white/20 flex items-center justify-center transition-colors duration-300 group-hover:border-[#ff1053] group-hover:bg-[#ff1053]/10">
                <TikTokIcon className="w-5 h-5" />
              </span>
              <span className="underline-offset-8 decoration-white/30 group-hover:underline group-hover:decoration-[#ff1053] group-hover:text-white text-white/85 transition-all duration-300">
                {t.handle}
              </span>
            </a>
          ))}
        </div>

        <div className="flex flex-col gap-5 lg:items-end justify-end">
          <SizeGuide />
          <a
            data-testid="footer-track-order"
            href="/track"
            className="text-[10px] uppercase tracking-[0.25em] text-white/45 hover:text-white transition-colors duration-300"
          >
            Track your order
          </a>
          <button
            data-testid="footer-back-to-top"
            onClick={() => scrollToId("top")}
            className="text-[10px] uppercase tracking-[0.25em] text-white/45 hover:text-white transition-colors duration-300"
          >
            Back to top
          </button>
        </div>
      </div>

      <Reveal>
        <div className="rounded-sm bg-gradient-to-b from-[#161616] to-[#0b0b0b] border border-white/5 px-4 sm:px-8 py-6 sm:py-10 shadow-[inset_0_1px_0_rgba(255,255,255,0.07)]">
          <p
            className="font-unbounded font-extrabold uppercase leading-[0.85] text-[12.5vw] whitespace-nowrap select-none text-emboss"
            aria-hidden="true"
          >
            A&F — 4ever
          </p>
        </div>
      </Reveal>

      <div className="flex flex-col sm:flex-row justify-between gap-3 mt-12 pt-8 border-t border-white/10 text-[10px] uppercase tracking-[0.22em] text-white/35">
        <p>© 2026 Always & Forever — Created by Monica Alexander</p>
        <p>Free shipping on everything · Made in Chicago · Sublimation & Airbrush</p>
      </div>
    </footer>
  );
}
